// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.L9ghRKEFeSE4_wxIkYYk{width:100%;margin-bottom:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorBanner": `L9ghRKEFeSE4_wxIkYYk`
};
export default ___CSS_LOADER_EXPORT___;
